import { Link } from '@tanstack/react-router';
import type { StravaReturnPath } from '@painpal/contracts';
import styles from './StravaReturnError.module.css';

export const STRAVA_RETURN_ERROR = 'Strava connection was cancelled or failed';

export function StravaReturnError({ error, path }: { error: string | undefined; path: StravaReturnPath }) {
  if (error === undefined) return null;
  return (
    <div className={`alert-hot ${styles.banner}`} role="alert">
      <span>{STRAVA_RETURN_ERROR}.</span>
      <Link to={path} className={styles.dismiss} aria-label="Dismiss Strava error">DISMISS ×</Link>
    </div>
  );
}
